export default __webpack_public_path__ + "static/media/@biancacperes.1c0a6c02.jpg";